let API_BASE, ASSETS_BASE, PROFILE_IMAGE_BASE, FIRM_IMAGE_BASE;

if (process.env.NODE_ENV === "production") {
  API_BASE = "https://api.firmconnector.com/index.php/";
  ASSETS_BASE = "https://api.firmconnector.com/assets/";
  PROFILE_IMAGE_BASE = "https://api.firmconnector.com/";
  FIRM_IMAGE_BASE = "https://api.firmconnector.com/";
} else {
  // API_BASE = "http://dev.firm-connector.com/";
  // ASSETS_BASE = "http://dev.firm-connector.com/assets/";
  // PROFILE_IMAGE_BASE = "http://dev.firm-connector.com/";
  // FIRM_IMAGE_BASE = "http://dev.firm-connector.com/";

  API_BASE = "https://api.firmconnector.com/index.php/";
  ASSETS_BASE = "https://api.firmconnector.com/assets/";
  PROFILE_IMAGE_BASE = "https://api.firmconnector.com/";
  FIRM_IMAGE_BASE = "https://api.firmconnector.com/";
}

export { API_BASE, ASSETS_BASE, PROFILE_IMAGE_BASE, FIRM_IMAGE_BASE };
